import React from 'react';
import './OrganizationLogos.css';

const OrganizationLogos = () => {
  // Define the style for organization names directly
  const orgNameStyle = {
    fontWeight: 700,
    color: '#E94057', // Explicitly using the hex color instead of CSS variable
    margin: '0 0.2rem'
  };
  
  // Style for the container with smaller text
  const containerStyle = {
    textAlign: 'center',
    margin: '1.5rem 0',
    padding: '0 1rem',
    fontSize: '0.9rem' // Smaller font size
  };

  return (
    <div style={containerStyle}>
      <p style={{ margin: '0 auto', maxWidth: '800px' }}>
        Guidelines from{' '}
        <span style={orgNameStyle}>Triple P</span>,{' '}
        <span style={orgNameStyle}>Red Nose Australia</span>,{' '}
        <span style={orgNameStyle}>Raising Children Network</span>, and{' '}
        <span style={orgNameStyle}>Tresillian</span>
      </p>
    </div>
  );
};

export default OrganizationLogos;
